import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "./AuthLayout";
import API from "../lib/api";
import { useT, localizeError } from "../components/home/i18n";

export default function ForgotPassword() {
  const { t } = useT();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const c = t.auth.forgot;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(localizeError(err.response?.data?.detail, t));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout testid="forgot-password-page" title={c.title} subtitle={c.subtitle}>
      {sent ? (
        <div data-testid="forgot-sent" className="space-y-4 text-sm text-[#2C2A29]">
          <p className="rounded-sm border border-[#E8E4DB] bg-[#FDFBF7] px-4 py-3">
            {c.sentPre}<strong>{email}</strong>{c.sentPost}
          </p>
          <Link to="/login" data-testid="back-to-login" className="block text-center font-semibold text-[#1F4A38]">{c.back}</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-medium text-[#5C5855]">{c.email}</label>
            <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="mt-1 w-full rounded-sm border border-[#E8E4DB] bg-white px-3 py-2.5 text-sm outline-none focus:border-[#1F4A38] focus:ring-1 focus:ring-[#1F4A38]" />
          </div>
          <button data-testid="forgot-submit" disabled={loading}
            className="w-full rounded-full bg-[#1F4A38] py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60">
            {loading ? c.submitting : c.submit}
          </button>
          <p className="text-center text-sm text-[#5C5855]">
            {c.remembered} <Link to="/login" data-testid="go-login" className="font-semibold text-[#1F4A38]">{c.signin}</Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
